module.exports = __webpack_public_path__ + "img/block-4.937ebcd6.svg";